import { Injectable } from '@angular/core';
import { Endpoints } from '../../../utils-ui/models/endpoints';
import { RequestService } from '../../../utils-ui/services/request/request.service';
import { IUserStorage } from '../../../utils-ui/models/userStorage';
import { StorageService } from '../../../utils-ui/services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  listSurvey = [];
  verifyServiceListActive = false;

  constructor(
    private readonly requestService: RequestService,
    private readonly storageService: StorageService
  ) {}

  async isActiveSurvey(nameSurvey: string): Promise<any> {
    const userInfo = this.storageService.getUser() as IUserStorage;

    if (!this.verifyServiceListActive) {
      this.listSurvey = await this.getActiveFrecuencySurvey(userInfo.identificationNumber);
      this.verifyServiceListActive = true;
    }

    return this.getValidateSurveyFrecuency(nameSurvey);
  }

  getValidateSurveyFrecuency(nameSurvey: string): any {
    if (this.listSurvey.length === 0) {
      return null;
    }
    const surveySel = this.listSurvey.find((survey) => survey.name === nameSurvey);
    const finalDateSurvey = new Date(surveySel.finish_date);

    if (!surveySel) {
      return null;
    }

    const actualDate = new Date();

    if (!surveySel.lastDateSurvey) {
      surveySel.lastDateSurvey = new Date();
    }

    if (actualDate.getTime() > finalDateSurvey.getTime()) {
      return null;
    }

    const startDate: Date = new Date();
    startDate.setMilliseconds(0);

    if (
      surveySel.unit_frecuency === 'DAY' ||
      surveySel.unit_frecuency === 'HOUR' ||
      surveySel.unit_frecuency === 'MINUTE'
    ) {
      startDate.setSeconds(0);
    }

    if (surveySel.unit_frecuency === 'DAY' || surveySel.unit_frecuency === 'HOUR') {
      startDate.setMinutes(0);
    }

    if (surveySel.unit_frecuency === 'DAY') {
      startDate.setHours(0);
    }

    if (surveySel.lastDateSurvey.getTime() < startDate.getTime()) {
      surveySel.count = 1;
    } else {
      surveySel.count++;
    }

    if (surveySel.count > surveySel.frecuency) {
      return null;
    }

    surveySel.lastDateSurvey = new Date();

    return surveySel;
  }

  getActiveFrecuencySurvey(advisorIdentificationNumber: string): Promise<any> {
    return this.requestService.get(Endpoints.ACTIVE_FRECUENCY_SURVEY, {
      headers: {
        'X-advisor-identification-number': advisorIdentificationNumber,
      },
      responseType: 'text',
    });
  }

  async orchCountRedirect(): Promise<void> {
    const userInfo = this.storageService.getUser() as IUserStorage;
    return this.requestService.post(Endpoints.HELPER_COUNTER_SERVICE, {
      headers: { 'X-RqUID': userInfo.rqUuid },
      body: { username: userInfo.username },
      responseType: 'text',
    });
  }
}
